import { AdresseModel } from './Adresse';
import { AppUtils } from '../../utils/index';
/**
 * Model for an differing account owner for the iban calculator sub application.
 */
export class AbwKontoInhaberModel {
	private adresse: AdresseModel;
	private name: string;
	private vorname: string;
	private anredeKennzeichen: number;
	private titel: string;
	private firmenname: string;
	private ansprechpartner: string;

	/**
	 * Salutation flag.
	 *
	 * @return 1 for 'Herr', 2 for 'Frau', 3 for "Familie", 4 for "Firma", 9 for "Keine"
	 */
	get AnredeKennzeichen(): number {
		return this.anredeKennzeichen;
	}

	/**
	 * Salutation flag.
	 *
	 * @param value 1 for 'Herr', 2 for 'Frau', 3 for "Familie", 4 for "Firma".
	 */
	set AnredeKennzeichen(value: number) {
		this.anredeKennzeichen = value;
	}

	get Titel(): string {
		return this.titel;
	}

	set Titel(value: string) {
		this.titel = value;
	}

	get Vorname(): string {
		return this.vorname;
	}

	set Vorname(value: string) {
		this.vorname = value;
	}

	get Name(): string {
		return this.name;
	}

	set Name(value: string) {
		this.name = value;
	}

	get Firmenname(): string {
		return this.firmenname;
	}

	set Firmenname(value: string) {
		this.firmenname = value;
	}

	get Ansprechpartner(): string {
		return this.ansprechpartner;
	}

	set Ansprechpartner(value: string) {
		this.ansprechpartner = value;
	}

	/**
	 * The adress object of the differing account owner.
	 *
	 * @return adress model.
	 */
	get Adresse(): AdresseModel {
		return this.adresse;
	}

	/**
	 * The adress object of the differing account owner.
	 *
	 * @param value adress model.
	 */
	set Adresse(value: AdresseModel) {
		this.adresse = value;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
	 * Creates a new AbwKontoInhaberModel object and copies the values from the provided data object (or other AbwKontoInhaber model) to the created AbwKontoInhaberModel.
	 */
	static createFromObject(dataObject: { [key: string]: any }): AbwKontoInhaberModel {
		return AppUtils.Helper.createFromMap(dataObject, AbwKontoInhaberModel, (key: string, value: any) => {
			if (key.toLowerCase() === 'adresse') {
				return AdresseModel.createFromObject(value);
			} else {
				return value;
			}
		});
	}
}